import React, { useEffect, useState } from 'react'
import styled from 'styled-components'

import Spinner from 'components/Spinner'

import useSearchParams from 'hooks/useSearchParams'

import Brand from 'helpers/brand'

import { PageHeader, PageTitle, SinglePanePage, screenSize } from 'styles/shared'

import Api from 'services/api'

import { color } from 'styles/colors'

const VerifyNotificationRecipient = () => {
  const token = useSearchParams('token')

  const [isSaving, setIsSaving] = useState(false)
  const [apiError, setApiError] = useState({ message: '', subMessage: '' })

  useEffect(() => {
    if (token) {
      setIsSaving(true)
      Api.NotificationRecipients.verify_email({ token })
        .then(() => {
          setIsSaving(false)
        })
        .catch(async (error) => {
          if (error.status === 400) {
            const errorResponse = await error.json()
            setApiError({ message: errorResponse?.base[0].name.replace(':', ''), subMessage: 'Resend another link' })
          } else if (error.status === 412) {
            const errorResponse = await error.json()
            setApiError({ message: errorResponse?.base[0].name.replace(':', ''), subMessage: 'Send a new link' })
          } else {
            setApiError({ message: 'Verification failed', subMessage: 'Send a new link' })
          }
          setIsSaving(false)
        })
    } else {
      setApiError({ message: 'Verification failed', subMessage: 'Send a new link' })
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  const Content = () => {
    if (isSaving) {
      return <Spinner variant="page" />
    } else if (apiError.message !== '') {
      return (
        <S.Content>
          <S.Heading>{apiError.message}</S.Heading>
          <S.Message>  <a href="/notifications">{apiError.subMessage}</a>  from Notification Recipients in Diagnostics.</S.Message>
        </S.Content>
      )
    } else {
      return (
        <S.Content>
          <S.Heading>Thanks for verifying your email.</S.Heading>
          <S.Message>You will now receive emails for the alerts that you have selected.</S.Message>
        </S.Content>
      )
    }
  }

  return (
    <S.Body>
      <S.PageHeader>
        <PageTitle>Email Verification</PageTitle>
        <S.ProductLogo src={Brand.productLogoPath()} alt={`${Brand.brandName()} logo`} />
      </S.PageHeader>
      <S.SinglePanePage>
        <S.BrandLogo src={Brand.brandLogoPath()} alt={`${Brand.productName()} logo`} />
        <Content />
      </S.SinglePanePage>
    </S.Body>
  )
}

export default VerifyNotificationRecipient

const S = {
  Body: styled.div`
    height: 100%;
    background-color: ${color('background')};
  `,
  PageHeader: styled(PageHeader)`
    align-items: center;
    justify-content: space-between;
    flex-direction: row;
  `,
  ProductLogo: styled.img`
    height: 36px;
  `,
  SinglePanePage: styled(SinglePanePage)`
    display: flex;

    @media ${screenSize.small} {
      margin-top: 0px;
      flex-direction: column-reverse;
      justify-content: center;
    }
  `,
  BrandLogo: styled.img`
    height: 34px;
    align-self: flex-end;

    @media ${screenSize.small} {
      align-self: center;
    }
  `,
  Content: styled.div`
    align-self: center;
    height: 100%;
    width: 100%;
    padding: 20px;
    margin-bottom: 10%;
    text-align: center;
    background-color: ${color('paneBackground')};
  `,
  Heading: styled.h1`
    margin-top: 50px;
    text-transform: initial;
    color: ${color('headerText')};
    font-size: 38px;
  `,
  Message: styled.p`
    text-transform: initial;
  `
}
